export default "__VITE_PUBLIC_ASSET__a1e7ca4b__"